import { render, staticRenderFns } from "./CorporationF.vue?vue&type=template&id=f855dba2&scoped=true"
import script from "./CorporationF.vue?vue&type=script&lang=js"
export * from "./CorporationF.vue?vue&type=script&lang=js"
import style0 from "./CorporationF.vue?vue&type=style&index=0&id=f855dba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f855dba2",
  null
  
)

export default component.exports